const SESSION_STORAGE_KEY = "stem_session_id";
const BRIDGE_VERSION = 1;

const ALLOWED_PARENT_ORIGINS = new Set([
  "https://sesh.fm",
  "https://www.sesh.fm",
  "http://localhost:3000",
  "http://127.0.0.1:3000",
]);

type BridgeMessage = {
  type?: unknown;
  version?: unknown;
};

function getParentOrigin(): string | null {
  if (window.parent === window || !document.referrer) return null;

  try {
    const origin = new URL(document.referrer).origin;
    return ALLOWED_PARENT_ORIGINS.has(origin) ? origin : null;
  } catch {
    return null;
  }
}

export function announceLegacySessionId(sessionId: string): void {
  const parentOrigin = getParentOrigin();
  if (!parentOrigin) return;

  window.parent.postMessage(
    {
      type: "sesh:stem-session-id:announce",
      version: BRIDGE_VERSION,
      sessionId,
    },
    parentOrigin,
  );
}

export function startLegacySessionBridge(): () => void {
  const parentOrigin = getParentOrigin();
  if (!parentOrigin) return () => undefined;

  const announceStoredId = () => {
    const sessionId = localStorage.getItem(SESSION_STORAGE_KEY);
    if (sessionId) announceLegacySessionId(sessionId);
  };

  const handleMessage = (event: MessageEvent<BridgeMessage>) => {
    if (event.origin !== parentOrigin || event.source !== window.parent) return;
    if (
      event.data?.type !== "sesh:stem-session-id:collect" ||
      event.data.version !== BRIDGE_VERSION
    ) {
      return;
    }

    announceStoredId();
  };

  window.addEventListener("message", handleMessage);
  announceStoredId();

  return () => window.removeEventListener("message", handleMessage);
}
